import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { deDE, enUS, esES, frFR, itIT, nlNL, plPL, ptBR, ruRU, zhCN } from '@mui/x-date-pickers/locales'

import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const languagesLocaleText = {
  pt: ptBR,
  en: enUS,
  es: esES,
  ru: ruRU,
  de: deDE,
  fr: frFR,
  it: itIT,
  pl: plPL,
  cn: zhCN,
  ar: enUS,
  nl: nlNL,
}

export const DatePickerProvider = ({ children }) => {
  const { i18n } = useTranslation()
const lang = i18n.language.split("-")[0];

  const localeText = useMemo(() => {
    const localeText =
      languagesLocaleText[lang] ?? languagesLocaleText["en"];
    return localeText?.components?.MuiLocalizationProvider?.defaultProps
      ?.localeText;
  }, [lang]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={lang === "zh" ? "zh-cn" : lang}
      localeText={localeText}
    >
      {children}
    </LocalizationProvider>
  );
}
